import { render, staticRenderFns } from "./MaterialListSheet.vue?vue&type=template&id=c470d61a&scoped=true&"
import script from "./MaterialListSheet.vue?vue&type=script&lang=ts&"
export * from "./MaterialListSheet.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialListSheet.vue?vue&type=style&index=0&id=c470d61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c470d61a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VSheet})
